import type { Storage } from '@/infra/storage'
import { type Sound, SoundPlayer } from './SoundPlayer'

/**
 * Plays the given sound, stops if the signal aborts.
 */
export type PlaySoundFn = (sound: Sound, signal?: AbortSignal) => unknown

/**
 * Options for the {@link SoundFeature}.
 */
export interface SoundFeatureOptions {
  storage: Storage
}

/**
 * Everything related to playing sounds.
 */
export type SoundFeature = ReturnType<typeof SoundFeature>

export function SoundFeature(options: SoundFeatureOptions) {
  // Not lazy-loaded because sounds may only play once the user has interacted
  // with the page, which must be handled in the same frame as the interaction.
  const soundPlayer = new SoundPlayer(options.storage)

  return {
    // Public
    playSound: soundPlayer.playSound,
  }
}

export type { Sound }
